<section class="tnq-banner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <span class="caseStudy">事例紹介</span>
                <div class="tnq-logo">
                    <span>
                        <img src="/assets/images/case-study/tnq-logo.png" alt="tnq logo" />
                    </span>
                    <span>
                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.4648 4.5H8.33984V0.375C8.33984 0.275544 8.30034 0.180161 8.23001 0.109835C8.15968 0.0395088 8.0643 0 7.96484 0L5.71484 0C5.61539 0 5.52 0.0395088 5.44968 0.109835C5.37935 0.180161 5.33984 0.275544 5.33984 0.375V4.5H1.21484C1.11539 4.5 1.02 4.53951 0.949679 4.60984C0.879353 4.68016 0.839844 4.77554 0.839844 4.875L0.839844 7.125C0.839844 7.22446 0.879353 7.31984 0.949679 7.39017C1.02 7.46049 1.11539 7.5 1.21484 7.5H5.33984V11.625C5.33984 11.7245 5.37935 11.8198 5.44968 11.8902C5.52 11.9605 5.61539 12 5.71484 12H7.96484C8.0643 12 8.15968 11.9605 8.23001 11.8902C8.30034 11.8198 8.33984 11.7245 8.33984 11.625V7.5H12.4648C12.5643 7.5 12.6597 7.46049 12.73 7.39017C12.8003 7.31984 12.8398 7.22446 12.8398 7.125V4.875C12.8398 4.77554 12.8003 4.68016 12.73 4.60984C12.6597 4.53951 12.5643 4.5 12.4648 4.5Z" fill="black"/>
                        </svg>
                    </span>
                    <span>
                        <img src="/assets/images/trinka_logo.svg" height="45px" alt="trinka logo" />
                    </span>
                </div>
                <h1>世界最大級の出版社に技術提供するTNQがTrinkaを言語品質評価に活用</h1>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm key-benefits">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-lg-3 col-md-12">
                <h5 class="mb-0 text-white">ハイライト</h5>
            </div>
            <div class="col-md-4 col-lg-3">
                <div class="key-content white-line">
                    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.2 6.7C19.2 4.2482 19.2 3.0236 18.4382 2.2618C17.6764 1.5 16.4518 1.5 14 1.5C11.5482 1.5 10.3236 1.5 9.5618 2.2618C8.8 3.0236 8.8 4.2482 8.8 6.7M1 17.1C1 12.1977 1 9.7459 2.5236 8.2236C4.0459 6.7 6.4977 6.7 11.4 6.7H16.6C21.5023 6.7 23.9541 6.7 25.4764 8.2236C27 9.7459 27 12.1977 27 17.1C27 22.0023 27 24.4541 25.4764 25.9764C23.9541 27.5 21.5023 27.5 16.6 27.5H11.4C6.4977 27.5 4.0459 27.5 2.5236 25.9764C1 24.4541 1 22.0023 1 17.1Z" stroke="white" stroke-width="1.5"/>
                        <path d="M14.0004 21.433C15.4369 21.433 16.6004 20.4632 16.6004 19.2672C16.6004 18.0712 15.4369 17.1001 14.0004 17.1001C12.5639 17.1001 11.4004 16.1303 11.4004 14.933C11.4004 13.737 12.5639 12.7672 14.0004 12.7672M14.0004 21.433C12.5639 21.433 11.4004 20.4632 11.4004 19.2672M14.0004 21.433V22.3001M14.0004 12.7672V11.9001M14.0004 12.7672C15.4369 12.7672 16.6004 13.737 16.6004 14.933" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                    <h6>年間50万ドル以上のコストカットの可能性に貢献</h6>
                </div>
            </div>
            <div class="col-md-4 col-lg-3">
                <div class="key-content">
                    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 24.875C6.7275 24.875 1.625 19.7725 1.625 13.5C1.625 7.2275 6.7275 2.125 13 2.125C19.2725 2.125 24.375 7.2275 24.375 13.5C24.375 19.7725 19.2725 24.875 13 24.875ZM13 3.75C7.62125 3.75 3.25 8.12125 3.25 13.5C3.25 18.8787 7.62125 23.25 13 23.25C18.3787 23.25 22.75 18.8787 22.75 13.5C22.75 8.12125 18.3787 3.75 13 3.75Z" fill="white"/>
                        <path d="M16.2501 17.5625C16.1038 17.5625 15.9576 17.53 15.8276 17.4488L11.7651 15.0113C11.6447 14.9389 11.5454 14.8364 11.477 14.7138C11.4086 14.5912 11.3734 14.4529 11.3751 14.3125V7.8125C11.3751 7.3575 11.7326 7 12.1876 7C12.6426 7 13.0001 7.3575 13.0001 7.8125V13.8575L16.6726 16.0512C16.8238 16.144 16.9407 16.2835 17.0056 16.4486C17.0704 16.6137 17.0797 16.7955 17.0319 16.9664C16.9841 17.1373 16.882 17.2879 16.7409 17.3955C16.5998 17.503 16.4275 17.5617 16.2501 17.5625Z" fill="white"/>
                    </svg>
                    <h6>ターンアラウンド・タイム（所要時間）の改善</h6>
                </div>
            </div>
            <div class="col-md-4 col-lg-3">
                <div class="key-content">
                    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_180_271)">
                        <path d="M2 15.4892H6.33333V24.1775H2V15.4892ZM9.58333 11.1883H13.9167V24.1775H9.58333V11.1883ZM23.645 6.83333L19.3117 2.5L14.9783 6.83333H17.145V24.1883H21.4783V6.83333H23.645Z" stroke="white" stroke-width="1.5"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_180_271">
                        <rect width="25.645" height="25.6883" fill="white" transform="translate(0 0.5)"/>
                        </clipPath>
                        </defs>
                    </svg>
                    <h6>言語評価全体の質の向上<br/>&nbsp;</h6>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <p class="w-100">STM（科学・技術・医学）出版社にとって、隙のない言語品質を確保することは絶対条件です。校正プロセスは極めて重要であり、効率性を高めるために絶えず進化し続けなければなりません。</p>
                    <p class="w-100">エンドツーエンド（E2E）のサービスや製品を提供するプロバイダーであるTNQと英文校正サービスを提供するエナゴは共同で、国際的な大手出版社に、AIを搭載したソリューション「Language Central」を提供させていただきました。</p>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="trinka-api">
                    <h4>Trinka APIが、エラーを分類し発生頻度のリストを提示</h4>
                    <div class="api_img">
                        <img src="/assets/images/case-study/trinka-api-graph.svg" loading="lazy" decoding="async" alt="stm publisher" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <div class="trinka_container">
        <div class="row">
            <div class="col-lg-5 col-md-5">
                <div class="tnq-note">
                    <p>Trinka AIを搭載したLanguage Centralは、研究論文の言語的な品質を評価し、言語スコアと適切な校正レベルを提示します。出版社は、AIによる評価を見た上で、原稿を最適な校正チーム、あるいは校正サービスプロバイダーにスムーズに引き渡すことができます。
                    </p>
                </div>
            </div>
            <div class="col-lg-6 offset-lg-1 col-md-7">
                <div class="review-statement">
                    <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M29.0454 1.65279L24.7063 9.19607C24.9605 9.05503 25.2572 8.9566 25.5966 8.90077C25.9345 8.84347 26.2739 8.81483 26.6147 8.81483C28.6715 8.81483 30.3999 9.52956 31.8 10.959C33.2016 12.3885 33.9023 14.1037 33.9023 16.1047C33.9023 18.1615 33.2016 19.8906 31.8 21.2922C30.3999 22.6938 28.6715 23.3945 26.6147 23.3945C24.6137 23.3945 22.8985 22.6938 21.469 21.2922C20.0396 19.8906 19.3248 18.1615 19.3248 16.1047C19.3248 15.401 19.4115 14.7399 19.5849 14.1213C19.7582 13.5043 20.0051 12.9225 20.3253 12.376L27.1524 0.550934C27.2508 0.38933 27.3809 0.257107 27.5425 0.154266C27.7041 0.0514278 27.8877 7.62939e-06 28.0934 7.62939e-06C28.5136 7.62939e-06 28.8294 0.183651 29.041 0.550934C29.2525 0.918219 29.254 1.2855 29.0454 1.65279ZM9.72111 1.65279L5.38202 9.19607C5.63618 9.05503 5.93294 8.9566 6.27231 8.90077C6.61021 8.84347 6.94885 8.81483 7.28822 8.81483C9.34501 8.81483 11.0742 9.52956 12.4757 10.959C13.8773 12.3885 14.5781 14.1037 14.5781 16.1047C14.5781 18.1909 13.8773 19.9266 12.4757 21.312C11.0742 22.7004 9.34501 23.3945 7.28822 23.3945C5.28872 23.3945 3.57425 22.6938 2.14478 21.2922C0.715305 19.8906 0.000572205 18.1615 0.000572205 16.1047C0.000572205 15.401 0.0872536 14.7399 0.260609 14.1213C0.433968 13.5043 0.680779 12.9225 1.00105 12.376L7.82813 0.550934C7.92656 0.38933 8.05658 0.257107 8.21818 0.154266C8.37979 0.0514278 8.56343 7.62939e-06 8.76911 7.62939e-06C9.18928 7.62939e-06 9.50514 0.183651 9.7167 0.550934C9.92678 0.918219 9.92826 1.2855 9.72111 1.65279Z" fill="#763393"/>
                    </svg>
                    <p>「私たちは、論文原稿を最適なスキルを持つ校正者にマッチングさせることで校正の質を向上させるための解決策を求められました。この要望に応えるべく、６か月におよぶLanguage Centralの試験運用を経て、MLモデル（機械学習モデル）が言語の質を正確に判定し、必要な介入のレベルを予測することについて、非常に大きな可能性を示すことができました。この結果は、出版物全体の品質を向上させるだけでなく、プロセスの効率化にもつながるものです。」</p>
                    <div class="review-by">
                        <h6>シャラド・ミッタル（Sharad Mittal）</h6>
                        <small>研究支援エナゴおよびTrinka AI創設者</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="use-case-section section-pd pt-0">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <div class="use-case-content">
                    <div class="use-content">
                        <div class="ts-content">
                            <h6>業界:</h6>
                            <p>STM出版</p>
                        </div>
                        <div class="ts-content">
                            <h6>導入目的:</h6>
                            <p>言語品質評価</p>
                        </div>
                        <div class="ts-content">
                            <h6>ソリューション:</h6>
                            <p>文法チェッカーAPI</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="trinka-title mb-0">
                    <h2 class="f-26">お客様が抱えていた課題</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p class="w-100">解決策としてTrinkaを導入する以前、TNQのエンドクライアントである学術出版社様はジャーナルのすべての論文に同レベルの校正を行っていましたが、実際には論文ごとに言語の質が大きく異なっていたかもしれなかったのです。論文によって差異があるにも関わらず、すべての投稿論文を同じレベルで詳細に評価するのはコストがかかり、特に人間が作業するには多大な労力を必要としていました。</p>
                    <ul style="padding-left: 20px;">
                        <li>一様なレベルで校正を行うことは言語品質の違いを考慮していない</li>
                        <li>詳細な校正・評価を行うにはコストと労力がかかる</li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6">
                <div class="trinka-title mb-0">
                    <h2 class="f-26">Trinkaが提供したソリューション</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p class="w-100">言語品質の評価を大幅に自動化し、ターンアラウンド・タイムを短縮、コストを削減できる分野を特定しました。最終的な目標は、著者の満足度を維持しながら、言語評価の全体的な質を向上させることでした。</p>
                     <ul style="padding-left: 20px;">
                        <li>2022年には、10,000本以上、10万ページ以上の論文を評価</li>
                        <li>この数は2023年に倍増し、20,000本以上の論文を評価</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd result-section">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <div class="trinka-title text-center mb-0">
                    <h2>結果</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>TNQのエンドクライアントである出版社は、短い期間に以下のマイルストーンを達成することができました。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-lg-5">
                <div class="media">
                    <div class="media-left">
                        <span></span>
                    </div>
                    <div class="media-body">
                        <p>ジャーナル単位から論文単位のワークフローに移行</p>
                    </div>
                </div>
                <div class="media">
                    <div class="media-left">
                        <span></span>
                    </div>
                    <div class="media-body">
                        <p>高レベルの校正が必要な論文には、英語を母国語とするコピーエディターを割り当てる</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-5 offset-lg-2">
                <div class="media">
                    <div class="media-left">
                        <span></span>
                    </div>
                    <div class="media-body">
                        <p>論文単位でプロセスを細分化することで、ターンアラウンド・タイムを短縮</p>
                    </div>
                </div>
                <div class="media">
                    <div class="media-left">
                        <span></span>
                    </div>
                    <div class="media-body">
                        <p>不必要な校正をなくすことで、年間50万ドル以上を節約</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="smart-language">
                    <div class="language-header">
                        <h5>Language Central導入以前</h5>
                        <span></span>
                        <h5>Language Central導入以降</h5>
                    </div>
                    <div class="smart-body">
                        <div class="smart-content">
                            <ul>
                                <li>間の校正者がすべての原稿の言語品質評価を実行</li>
                                <li>1つのジャーナルで1つの校正レベルを一括規定</li>
                                <li>一定の所要時間と費用が必要</li>
                            </ul>
                        </div>
                        <div class="arrow-icon">
                            <svg width="30" height="40" viewBox="0 0 30 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.403099 7.52939C0.274336 7.38627 0.173673 7.21791 0.106856 7.03392C0.0400391 6.84994 0.00837612 6.65393 0.0136776 6.45709C0.0189791 6.26025 0.0611401 6.06644 0.137753 5.88672C0.214365 5.70699 0.323929 5.54488 0.460189 5.40963C0.596449 5.27439 0.756738 5.16865 0.931902 5.09847C1.10707 5.02829 1.29367 4.99503 1.48107 5.0006C1.66847 5.00617 1.85299 5.05045 2.0241 5.13092C2.19521 5.21139 2.34955 5.32648 2.47831 5.4696L14.6099 18.9617C14.8604 19.24 15 19.6085 15 19.9916C15 20.3746 14.8604 20.7431 14.6099 21.0215L2.47831 34.5151C2.3504 34.6613 2.19609 34.7794 2.02436 34.8625C1.85262 34.9456 1.66688 34.992 1.47792 34.9991C1.28896 35.0061 1.10055 34.9737 0.923635 34.9036C0.746717 34.8335 0.584821 34.7272 0.447349 34.5908C0.309875 34.4545 0.199566 34.2908 0.122828 34.1093C0.0460911 33.9278 0.00445557 33.7321 0.000338554 33.5335C-0.00377846 33.335 0.029706 33.1375 0.0988474 32.9527C0.167989 32.7678 0.271408 32.5993 0.403099 32.4568L11.6098 19.9916L0.403099 7.52939Z" fill="#763393"/>
                                <path d="M10.5375 3.37252C10.3658 3.18169 10.2316 2.95721 10.1425 2.7119C10.0534 2.46658 10.0112 2.20524 10.0182 1.94279C10.0253 1.68034 10.0815 1.42192 10.1837 1.18229C10.2858 0.942659 10.4319 0.726508 10.6136 0.546178C10.7953 0.365847 11.009 0.224869 11.2425 0.131293C11.4761 0.0377173 11.7249 -0.0066248 11.9748 0.000799535C12.2246 0.00822387 12.4707 0.0672689 12.6988 0.174563C12.9269 0.281858 13.1327 0.435301 13.3044 0.626131L29.4798 18.6156C29.8139 18.9867 30 19.478 30 19.9888C30 20.4995 29.8139 20.9908 29.4798 21.362L13.3044 39.3534C13.1339 39.5484 12.9281 39.7059 12.6991 39.8167C12.4702 39.9274 12.2225 39.9893 11.9706 39.9987C11.7186 40.0081 11.4674 39.9649 11.2315 39.8714C10.9956 39.778 10.7798 39.6363 10.5965 39.4545C10.4132 39.2727 10.2661 39.0544 10.1638 38.8124C10.0615 38.5704 10.0059 38.3094 10.0005 38.0447C9.99496 37.78 10.0396 37.5167 10.1318 37.2703C10.224 37.0238 10.3619 36.799 10.5375 36.609L25.4797 19.9888L10.5375 3.37252Z" fill="#763393"/>
                            </svg>
                        </div>
                        <div class="smart-content">
                            <ul>
                                <li>MLベース（機械学習ベース）の言語プロファイラが言語品質を評価</li>
                                <li>論文ごとに校正レベルを規定</li>
                                <li>所要時間の短縮とコスト削減</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="collaborate-stm section-pd">
    <div class="trinka_container">
        <div class="row">
            <div class="col-lg-12">
                <div class="review-statement">
                    <svg width="34" height="24" viewBox="0 0 34 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M29.0454 1.65279L24.7063 9.19607C24.9605 9.05503 25.2572 8.9566 25.5966 8.90077C25.9345 8.84347 26.2739 8.81483 26.6147 8.81483C28.6715 8.81483 30.3999 9.52956 31.8 10.959C33.2016 12.3885 33.9023 14.1037 33.9023 16.1047C33.9023 18.1615 33.2016 19.8906 31.8 21.2922C30.3999 22.6938 28.6715 23.3945 26.6147 23.3945C24.6137 23.3945 22.8985 22.6938 21.469 21.2922C20.0396 19.8906 19.3248 18.1615 19.3248 16.1047C19.3248 15.401 19.4115 14.7399 19.5849 14.1213C19.7582 13.5043 20.0051 12.9225 20.3253 12.376L27.1524 0.550934C27.2508 0.38933 27.3809 0.257107 27.5425 0.154266C27.7041 0.0514278 27.8877 7.62939e-06 28.0934 7.62939e-06C28.5136 7.62939e-06 28.8294 0.183651 29.041 0.550934C29.2525 0.918219 29.254 1.2855 29.0454 1.65279ZM9.72111 1.65279L5.38202 9.19607C5.63618 9.05503 5.93294 8.9566 6.27231 8.90077C6.61021 8.84347 6.94885 8.81483 7.28822 8.81483C9.34501 8.81483 11.0742 9.52956 12.4757 10.959C13.8773 12.3885 14.5781 14.1037 14.5781 16.1047C14.5781 18.1909 13.8773 19.9266 12.4757 21.312C11.0742 22.7004 9.34501 23.3945 7.28822 23.3945C5.28872 23.3945 3.57425 22.6938 2.14478 21.2922C0.715305 19.8906 0.000572205 18.1615 0.000572205 16.1047C0.000572205 15.401 0.0872536 14.7399 0.260609 14.1213C0.433968 13.5043 0.680779 12.9225 1.00105 12.376L7.82813 0.550934C7.92656 0.38933 8.05658 0.257107 8.21818 0.154266C8.37979 0.0514278 8.56343 7.62939e-06 8.76911 7.62939e-06C9.18928 7.62939e-06 9.50514 0.183651 9.7167 0.550934C9.92678 0.918219 9.92826 1.2855 9.72111 1.65279Z" fill="#763393"/>
                    </svg>
                    <p>「畳み込みニューラルネットワーク（CNN または ConvNe）)上に構築されたLanguage Centralは、ディープラーニングモデルと言語学的情報に基づくルールベースのシステムを活用しています。文の構造、単語の構成、テキストのシーケンス、スペル、単語の類似パターンに基づいてコンテンツを文章レベルで評価し、ジャーナル論文あるいは書籍の章としてすべてを集約します。Language Centralは、TNQの25年におよぶ校正の経験と、Language Centralのコアの一部として導入したエナゴのTrinkaとのパートナーシップにより、3年の歳月をかけて開発されたものです。」</p>
                    <div class="inCollab">
                        <div class="review-by">
                            <h6>シャンティ・クリシュナムルティ（Shanthi Krishnamoorthy）</h6>
                            <small>TNQ Tech Private Limited、研究開発部長</small>
                        </div>
                        <div class="collab-with">
                            <small>In collaboration with</small>
                            <img src="/assets/images/trinka_logo.svg" height="45px" alt="trinka logo" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Automate Your Editorial Workflows with Trinka AI</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button (click)="navigationService.goToEnterpriseForm()" class="white-btn" type="button">Contact Us</button>
                </div>
            </div>
        </div>  
    </div>
</section> -->